<template>
  <ReassuranceItem>
    <template #icon>
      <IconTruckExpress />
    </template>
    <template #content>
      <div class="flex flex-col">
        <span class="caption">
          {{
            i18n(translations.deliveryDateCaption, {
              date: i18n.date(new Date(), DATE_FORMAT),
            })
          }}
        </span>
        <FormattedMessage
          class="body-2"
          :definition="translations.deliveryDate"
        >
          <template #date>
            <span class="body-2-bold"
              >{{ freeMinDate }} - {{ freeMaxDate }}</span
            >
          </template>
        </FormattedMessage>
      </div>
    </template>
  </ReassuranceItem>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconTruckExpress } from '@ds/icons/IconTruckExpress'

import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'

import translations from './ItemDeliveryDate.translations'

interface ItemDeliveryDateProps {
  shipping: NonNullable<GetPickersResponse['selectedOffer']>['shipping']
}

const props = defineProps<ItemDeliveryDateProps>()

const i18n = useI18n()
const DATE_FORMAT: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
}

const freeMinDate = computed(() => {
  return props.shipping?.free
    ? i18n.date(new Date(props.shipping.free.earliestArrivalDate), DATE_FORMAT)
    : null
})

const freeMaxDate = computed(() => {
  return props.shipping?.free
    ? i18n.date(new Date(props.shipping.free.latestArrivalDate), DATE_FORMAT)
    : null
})
</script>
